module.exports = __webpack_public_path__ + "static/media/happy-avatars-placeholders.72142961.jpg";